import Slider from "@react-native-community/slider";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import * as Colors from "../../../styles/colors";

export default function SliderDistance({ radiosCircle, setRadiosCircle }) {
  return (
    <View style={styles.view}>
      <Text>
        {"Distância"}
      </Text>
      <Slider
        style={{ width: "75%" }}
        minimumValue={3000}
        value={radiosCircle}
        step={3000}
        maximumValue={21000}
        maximumTrackTintColor={Colors.GRAY_DARK}
        minimumTrackTintColor={Colors.PRIMARY}
        thumbTintColor={Colors.SECONDARY}
        onSlidingComplete={setRadiosCircle}
      />
      <Text>{radiosCircle <= 18000 ? radiosCircle / 1000 + " km" : "Max"}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  view: {
    marginTop:64,
    alignItems: "center",
    backgroundColor: Colors.WHITE,
    marginBottom: 16,
    padding: 4,
    borderRadius: 8,
    opacity: 0.9,
    flexDirection: "row"
  },
});
